<template>
    <div class="wrap">
        <div class="login-content section-one"></div>
        <div class="login-content section-two">
            <div class="section-wrap left">
                <img src="@/assets/images/login-bg-repeat1.png">
            </div>
            <div class="section-wrap center">
                <div class="login-form">
                    <div class="error-tips">
                        <b></b>
                    </div>
                    <div class="input-item">
                        <label class="name-label"></label>
                        <select class="login-role" v-model="role_type">
                            <option value="1">平台管理人</option>
                            <option value="2">采购人</option>
                            <option value="3">供应商</option>
                        </select>
                    </div>
                    <div class="input-item ">
                        <label class="name-label"></label>
                        <input type="text" v-model="username" placeholder="账户">
                    </div>
                    <div class="input-item">
                        <label class="pwd-label"></label>
                        <input type="password" v-model="password" placeholder="密码">
                    </div>
                    <input type="hidden" value="1464">
                    <button type="button" style="margin-bottom:10px;" @click="login()"><span>登录</span></button>
                    <button class="btn-primary" type="button" style="width:150px;margin-right:2px"><a
                            href="http://admin.gdslzb.cn/admin/register" target="_blank">注册</a></button>
                </div>
            </div>
            <div class="section-wrap right">
                <img src="@/assets/images/login-bg-repeat2.png">
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { mapActions } from "vuex"
import md5 from 'js-md5';

export default {
    name: "login",
    data () {
        return {
            role_type: 2,
            username: '',
            password: '',
            params: {
                s_type: this.$route.query.s_type,
                id: this.$route.query.id,
            }
        }
    },
    components: {
    },
    mounted () {
        let params = this.$route.query
        console.log(this.$route.query); // 输出 vue
    },
    computed: {

    },
    created () { },
    methods: {
        ...mapActions({
            doAdminUserLogin: "login/doAdminUserLogin",
        }),
        login () {
            let param = {
                username: this.username,
                password: md5(this.password),
                role_type: this.role_type
            }
            console.log(param)
            this.doAdminUserLogin({
                data: param, success: (res) => {
                    console.log(res)
                    if (res.code == 1) {
                        const token = res.data.token;
                        // 校验 token 是否存在
                        if (!token) {
                            this.$message.error('登录失败：未获取到有效凭证');
                            return;
                        }

                        this.$router.push({name: 'platform', query: this.params});

                    } else {
                        this.$message({
                            message: res.info,
                            type: 'error'
                        })
                    }
                }
            })
        }
    }
}
</script>

<style scoped>
.wrap {
    width: 100vw;
    /* height: 100vh; */
    overflow: hidden;
    user-select: none;
    background-color: #fff;
}

.login-content.section-one {
    margin-top: -300px;
    height: 60px;
}

.login-content {
    position: relative;
    width: 1024px;
    margin: auto;
    top: 50%;
}

.login-title {
    display: block;
    font-size: 2em;
    font-weight: bold;
}

.login-content.section-two {
    position: relative;
    width: 100%;
}

.section-wrap {
    position: absolute;
    top: 0;
    width: 50%;
    height: 524px;
    z-index: 0;
}

.section-wrap.left {
    left: 0;
}

.section-wrap.right {
    right: 0;
}

.section-wrap img {
    width: 100%;
    height: 100%;
}

.section-wrap.center {
    position: relative;
    margin: auto;
    width: 1024px;
    z-index: 1;
    background: url('../../assets/images/login-bg.jpg')
}

.login-form {
    position: absolute;
    right: 57px;
    top: 80px;
    height: 300px;
    width: 306px;
    background: #fff;
    padding: 70px 20px 0 20px;
    box-shadow: 5px 10px 20px 2px rgba(0, 0, 0, .27);
}

.error-tips {
    position: absolute;
    top: 20px;
    text-indent: 3px;
    height: 30px;
    line-height: 33px;
    width: 276px;
    color: #a94442;
    background-color: #f2dede;
    border: 1px solid #ebccd1;
    border-radius: 2px;
    display: none;
    padding-left: 30px;
}

.error-tips b {
    position: absolute;
    top: 50%;
    left: 10px;
    display: block;
    margin-top: -8px;
    width: 16px;
    height: 16px;
    overflow: hidden;
    background: url('../../assets/images/login-icons.png') -104px -49px no-repeat;
}

.input-item {
    width: 100%;
    height: 38px;
    margin-bottom: 20px;
    border: 1px solid #bdbdbd;
    position: relative;
}

.login-role {
    width: 220px;
    background-color: #fff;
    border: 1px solid #ccc;
    height: 30px;
    vertical-align: middle;
    padding: 4px 6px;
    margin-bottom: 10px;
    font-size: 14px;
    margin-left: 50px;
    margin-top: 4px;
}

.input-item>label {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 38px;
    height: 100%;
    border-right: 1px solid #bdbdbd;
    background: url('../../assets/images/login-icons.png') no-repeat;
}

.input-item>input {
    height: 20px;
    line-height: 20px;
    border: 0;
    padding: 9px 0 9px 50px;
    width: 256px;
    font-size: 16px;
}

.input-item>.name-label {
    background-position: 0 0;
}

.input-item>.pwd-label {
    background-position: -48px 0;
}

button {
    background-color: #427fed;
    width: 100%;
    border-radius: 2px;
    height: 40px;
    font-size: 16px;
    color: #fff;
    border: 0;
    cursor: pointer;
}
</style>
